import "core-js/modules/es6.number.constructor";
var DEG_TO_RAD = Math.PI / 180;
var MAX_NUM = Number.MAX_VALUE;
var MIN_NUM = -Number.MAX_VALUE;
export { DEG_TO_RAD, MAX_NUM, MIN_NUM };